import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CovanceMaterialModule } from '../../covance-material';
import { AgGridModule } from 'ag-grid-angular/main';
import { MdlModule } from '@angular-mdl/core';
import { MdlSelectModule } from '@angular-mdl/select';
import { MdlPopoverModule } from '@angular-mdl/popover';
import { CvdModule } from '@covance/ng-cvd3';
import { FormatDatePipe } from './format-date.pipe';
import { FormatDateTimePipe } from './format-date-time.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { MultilineFormatter } from './multiline-formatter';
import { UnitSelectorComponent } from './unit-selector.component';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './footer.component';
import { CovanceSelectDropdownComponent } from '../covance-dropdown-select/covance-dropdown-select.component';
import { DataRevisionIndicatorComponent } from './data-revision/data-revision-indicator.component';
import { DataRevisionIndicator } from './data-revision/data-revision-indicator';
import { MillisecondsConverterPipe } from './milliseconds-converter.pipe';
import { TooltipFormatter } from './tooltip-formatter';
import { CovanceSelectModule } from '../covance-select/covance-select.module';
import { UserPreferencesModule } from '../user-preferences/user-preferences.module';
import { ClearableTextfield } from './clearable-textfield/clearable-textfield.component';
import { DownloadDialogComponent } from './document-downloader/download-dialog.component';
import { CovanceExpansionPanelComponent } from './covance-expansion-panel/covance-expansion-panel.component';
import { TrackingGridComponent } from './covance-grid/tracking-grid/tracking-grid.component';
import { PaginationComponent } from './covance-grid/pagination/pagination.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TimeframeFilterComponent } from './time-frame-filter/timeframe-filter.component';
import { MyDatePickerModule } from 'mydatepicker';
import { TrackingGridService } from './covance-grid/tracking-grid.service';
import { SelectComponent } from '../sample-tracking/reports/new-report/filters/select/select.component';
import { SearchBarComponent } from '../sample-tracking/service/search-bar/search-bar.component';
import { DeleteModalComponent } from '../shared/model-dialog/delete/delete-modal.component';
import { ColumnSettingsComponent } from './covance-grid/column-settings/component/column-settings.component';
import { ColumnSettingsService } from './covance-grid/column-settings/service/column-settings.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NotificationFormFieldComponent } from '../sample-tracking/sample-monitoring/notification-form/notification-form-field/notification-form-field.component';
import { NavigationServiceComponent } from '../sample-tracking/service/navigation-service/navigation-service.component';
import { PendoService } from './pendo-service/pendo-service';
import { SampleActivityComponent } from '../sample-tracking/tracking-overview/sample-activity/sample-activity.component';
import { CourierModelComponent } from './courier-model/courier-model.component';
import { CourierModelService } from './courier-model/courier-model-service';
import { CourierModelDialogService } from './courier-model/courier-model-dialog-service';
import { SampleTrackingSelectComponent } from '../sample-tracking/shared/sample-tracking-select/sample-tracking-select.component';
import { SampleTrackingSelectFilterService } from '../sample-tracking/shared/sample-tracking-select/sample-tracking-select-filter-service';
import { SnackBarComponent } from '../shared/snack-bar/snack-bar.component';
import { SnackbarService } from '../shared/snack-bar/snack-bar.service';
const agGrid = AgGridModule.withComponents([]);

@NgModule({
    providers: [
        MultilineFormatter,
        DataRevisionIndicator,
        TooltipFormatter,
        TrackingGridService,
        ColumnSettingsService,
        PendoService,
        CourierModelService,
        SampleTrackingSelectFilterService,
        CourierModelDialogService,
        SnackbarService
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        CovanceMaterialModule,
        RouterModule,
        agGrid,
        MdlModule,
        MdlSelectModule,
        MdlPopoverModule,
        CvdModule,
        CovanceSelectModule,
        UserPreferencesModule,
        MyDatePickerModule,
        DragDropModule
    ],
    declarations: [
        FormatDatePipe,
        FormatDateTimePipe,
        SafeHtmlPipe,
        UnitSelectorComponent,
        FooterComponent,
        CovanceSelectDropdownComponent,
        DataRevisionIndicatorComponent,
        MillisecondsConverterPipe,
        DownloadDialogComponent,
        ClearableTextfield,
        CovanceExpansionPanelComponent,
        TrackingGridComponent,
        PaginationComponent,
        SpinnerComponent,
        TimeframeFilterComponent,
        SelectComponent,
        SearchBarComponent,
        DeleteModalComponent,
        ColumnSettingsComponent,
        NotificationFormFieldComponent,
        NavigationServiceComponent,
        SampleActivityComponent,
        CourierModelComponent,
        SampleTrackingSelectComponent,
        SnackBarComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        CovanceMaterialModule,
        RouterModule,
        AgGridModule,
        MdlModule,
        MdlSelectModule,
        MdlPopoverModule,
        CvdModule,
        FormatDatePipe,
        FormatDateTimePipe,
        SafeHtmlPipe,
        UnitSelectorComponent,
        FooterComponent,
        CovanceSelectDropdownComponent,
        DataRevisionIndicatorComponent,
        MillisecondsConverterPipe,
        ClearableTextfield,
        CovanceSelectModule,
        UserPreferencesModule,
        DownloadDialogComponent,
        CovanceExpansionPanelComponent,
        TrackingGridComponent,
        PaginationComponent,
        SpinnerComponent,
        TimeframeFilterComponent,
        SelectComponent,
        SearchBarComponent,
        DeleteModalComponent,
        ColumnSettingsComponent,
        NotificationFormFieldComponent,
        NavigationServiceComponent,
        SampleActivityComponent,
        SampleTrackingSelectComponent,
        SnackBarComponent
    ],
    entryComponents: [
        DownloadDialogComponent,
        DeleteModalComponent,
        ColumnSettingsComponent,
        CourierModelComponent,
    ],
})
export class SharedModule { }
